
export default {
  name: 'PrivacyPolicyDialog',
  props: {
    showPrivacyDialog: { type: Boolean, default: false },
    urlPrivacyPolicy: { type: String, default: '' },
  },
  data() {
    return {
      showDialog: false,
      confirmCheckbox: false,
      validFormPrivacy: false,
    }
  },
  computed: {
    rulesConfirm() {
      return [this.confirmCheckbox || 'Debes aceptar el aviso de privacidad']
    },
  },
  watch: {
    showPrivacyDialog(val) {
      this.showDialog = val
    },
  },
  mounted() {
    if (
      this.showPrivacyDialog !== null &&
      this.showPrivacyDialog !== undefined
    ) {
      this.showDialog = this.showPrivacyDialog
    }
  },
  methods: {
    async validate() {
      const isValid = this.$refs.formPrivacy.validate()

      if (isValid) {
        await this.$emit('acceptPrivacy')
      } else {
        const element = document.getElementById('submitFormPrivacy')

        element.disabled = true
        element.classList.add('v-btn--disabled')
        this.$store.dispatch('notifications/open', {
          color: 'error',
          text: 'Formulario inválido',
        })
      }
    },
  },
}
